const url = new URL(window.location);

if (url.pathname === "/account") {
  const elements = document.querySelectorAll('a[href="/account/logout"]');
  elements.forEach(function (element) {
    element.href = element.href + "?logout=true";
  });
}

if (url.pathname === "/account" && url.searchParams.get("logout") === "true") {
  const user = theme.customer;
  const eventData = {
    "customer - logged in": user.isLoggedIn,
    "customer - shopify id": user.id,
    "customer - email": user.email ? user.email : "",
    "customer - total orders":
      user.orders_count || user.orders_count === 0 ? user.orders_count : "",
    "customer - total spent":
      user.total_spent || user.total_spent === 0
        ? (user.total_spent / 100).toFixed(2)
        : "",
  };

  window.maestro.fireTrackEvent("successfulSignOut", eventData);
  url.searchParams.delete("logout");
  history.replaceState({}, "", url);
}
